module.exports = __webpack_public_path__ + "img/spike.8be60642.png";